import React from 'react';

import { StyledPageHeader } from './PageHeader.styles';
import { TPageHeaderProps } from './PageHeader.types';

const PageHeader = ({ paddingX = 'xl', children, ...props }: TPageHeaderProps) => (
  <StyledPageHeader $paddingX={paddingX} {...props}>
    {children}
  </StyledPageHeader>
);

export default PageHeader;
